/* This file is autogenerated, see readme.md for instructions */
import SurveySvgIcon from '@bloomreach/banana-theme/icons/survey.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SurveyIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SurveySvgIcon />
    </Icon>
  );
});

SurveyIcon.displayName = 'SurveyIcon';

export default SurveyIcon;
